import React, { createContext, useState, useContext, ReactNode } from "react";

interface PasswordModalContextType {
  isOpen: boolean;
  openPasswordModal: () => void;
  closePasswordModal: () => void;
  error: string;
  setError: React.Dispatch<React.SetStateAction<string>>;
  success: string;
  setSuccess: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const PasswordModalContext = createContext<
  PasswordModalContextType | undefined
>(undefined);

interface PasswordModalProviderProps {
  children: ReactNode;
}

export const PasswordModalProvider: React.FC<PasswordModalProviderProps> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const openPasswordModal = (): void => {
    setIsOpen(true);
    setError("");
    setSuccess("");
  };

  const closePasswordModal = (): void => {
    setIsOpen(false);
    setError("");
    setSuccess("");
  };

  return (
    <PasswordModalContext.Provider
      value={{
        isOpen,
        openPasswordModal,
        closePasswordModal,
        error,
        setError,
        success,
        setSuccess,
        loading,
        setLoading,
      }}
    >
      {children}
    </PasswordModalContext.Provider>
  );
};

export const usePasswordModal = (): PasswordModalContextType => {
  const context = useContext(PasswordModalContext);
  if (context === undefined) {
    throw new Error(
      "usePasswordModal must be used within a PasswordModalProvider"
    );
  }
  return context;
};
